import { ColumnsType } from "antd/es/table";
import classNames from "classnames";

// Type definition
export type SourceMetric = {
  source: string;
  users: number;
  change: string;
};
type MostViewed = {
  dashboard_name: string;
  view_count: number;
  user_count: number;
};
type ApiHealth = {
  service: string;
  status: string;
  latency: string;
  last_updated: string;
};
export const mostConnectedColumns: ColumnsType<SourceMetric> = [
  {
    title: "Source",
    dataIndex: "source",
    key: "source",
  },
  {
    title: "Users",
    dataIndex: "users",
    key: "users",
  },
  {
    title: "Change",
    dataIndex: "change",
    key: "change",
    render: (text: string) => {
      const displayText = text?.trim() || "0.0%";
      let badgeClass = "status-badge--neutral";

      if (displayText.includes("+")) {
        badgeClass = "status-badge--positive";
      } else if (displayText.includes("-")) {
        badgeClass = "status-badge--negative";
      }

      return (
        <span className={classNames("status-badge", badgeClass)}>
          {displayText}
        </span>
      );
    },
  },
];

export const getIconForPriority = (priority: string) => {
  switch ((priority || "").toUpperCase()) {
    case "HIGH":
      return "🔥";
    case "MEDIUM":
      return "⚠️";
    case "LOW":
      return "✅";
    case "INFO":
      return "ℹ️";
    default:
      return "⚠️";
  }
};

export const mostViewedColumns: ColumnsType <MostViewed> = [
  {
    title: "Dashboard",
    dataIndex: "dashboard_name",
    key: "dashboard_name",
  },
  {
    title: "Views",
    dataIndex: "view_count",
    key: "view_count",
  },
  {
    title: "Users",
    dataIndex: "user_count",
    key: "user_count",
  },
];

export const apiHealthColumns: ColumnsType<ApiHealth> = [
  {
    title: "Service",
    dataIndex: "service",
    key: "service",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (text: string) => {
      const status = (text || "default").toLowerCase().replace(/\s+/g, "-");
      const badgeClass = `status-badge status-badge--${status}`;
      return <span className={badgeClass}>{text || "Unknown"}</span>;
    },
  },
  {
    title: "Latency",
    dataIndex: "latency",
    key: "latency",
  },
  {
    title: "Last Updated",
    dataIndex: "last_updated",
    key: "last_updated",
  },
];
